import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useActivityTracker } from '../../hooks/useActivityTracker';
import { BVTConstants } from '../../utils/BVTConstants';

export const InactivityWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const { resetTimer, getTimeUntilLogout } = useActivityTracker();

  useEffect(() => {
    const checkInactivity = () => {
      const timeUntilLogout = getTimeUntilLogout();
      
      if (timeUntilLogout <= BVTConstants.SESSION_WARNING_THRESHOLD && timeUntilLogout > 0) {
        setShowWarning(true);
        setTimeLeft(Math.ceil(timeUntilLogout / 1000 / 60)); // Convert to minutes
      } else {
        setShowWarning(false);
      }
    };

    const interval = setInterval(checkInactivity, 10000); // Check every 10 seconds

    return () => clearInterval(interval);
  }, [getTimeUntilLogout]);

  const handleStayLoggedIn = () => {
    resetTimer();
    setShowWarning(false);
  };

  const handleLogout = () => {
    setShowWarning(false);
    // The activity tracker will handle the logout
    window.location.href = '/login';
  };

  return (
    <Dialog 
      open={showWarning} 
      onClose={handleStayLoggedIn}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Session Timeout Warning
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1">
            You have been inactive for a while. Your session will expire in{' '}
            <strong>{timeLeft} minute{timeLeft !== 1 ? 's' : ''}</strong>.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Click "Stay Logged In" to continue your session, or you will be automatically logged out.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogout} color="error">
          Logout Now
        </Button>
        <Button onClick={handleStayLoggedIn} variant="contained" autoFocus>
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 